// App.js (Updated to include new components)
import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Mission from './components/Mission';
import Programs from './components/Programs';
import Gallery from './components/Gallery';
import Impact from './components/Impact';
import Partners from './components/Partners';
import GetInvolved from './components/GetInvolved';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Mission />
      <Programs />
      <Gallery />
      <Impact />
      <Partners />
      <GetInvolved />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;